import { render, staticRenderFns } from "./MobileDashboard.vue?vue&type=template&id=051981f9&scoped=true&"
import script from "./MobileDashboard.vue?vue&type=script&lang=js&"
export * from "./MobileDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MobileDashboard.vue?vue&type=style&index=0&id=051981f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051981f9",
  null
  
)

export default component.exports